<template>
  <Form as="div" ref="Form">
    <fieldset>
      <legend><h3 v-html="title" /></legend>
      <div class="control push-down">
        <div class="radio-inline">
          <Field
            id="bookingAsap"
            v-model="bookingChoice"
            :rules="{ required: bookingChoice === null }"
            type="radio"
            name="BookingChoice"
            :value="true"
            data-vv-as="Valg"
            :label="pickCallOptionError"
            @change="$emit('update:model-value', bookingChoice)"
          />
          <label for="bookingAsap" v-html="questionAsap" />
        </div>
        <div class="radio-inline">
          <Field
            id="bookingChoose"
            v-model="bookingChoice"
            :rules="{ required: bookingChoice === null }"
            type="radio"
            name="BookingChoice"
            :value="false"
            data-vv-as="Valg"
            :label="pickCallOptionError"
            @change="$emit('update:model-value', bookingChoice)"
          />
          <label for="bookingChoose" v-html="questionChoose" />
        </div>
        <div>
          <ValidationError name="BookingChoice" />
        </div>
      </div>
      <div class="control">
        <button
          class="button large"
          data-test-callme-button
          @click="emitBookingChoice"
          v-html="buttonLabel"
        />
      </div>
    </fieldset>
  </Form>
</template>

<script lang="ts">
import ValidationError from '@/components/UI/ValidationError.vue';
import { Form, ValidationResult } from 'vee-validate';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CallMeBookingChoice',
  components: {
    ValidationError
  },
  props: {
    title: {
      type: String,
      default() {
        return 'Hvornår vil du ringes op?';
      }
    },
    questionAsap: {
      type: String,
      default() {
        return 'Hurtigst muligt';
      }
    },
    questionChoose: {
      type: String,
      default() {
        return 'Vælg selv tidspunkt';
      }
    },
    buttonLabel: {
      type: String,
      default() {
        return 'Næste';
      }
    },
    pickCallOptionError: {
      type: String,
      default() {
        return 'Valg ';
      }
    },
  },
  data() {
    return {
      bookingChoice: null
    };
  },
  methods: {
    emitBookingChoice(): void {
      (this.$refs.Form as typeof Form).validate().then((result: ValidationResult) => {
        if (!result.valid) return;
        this.$emit('booking-choice');
      });
    }
  }
});
</script>
